import { useEffect, useState } from "react";
import LoadingPlaceholder from "../components/ui/LoadingPlaceholder";
import { fetchCurrentAdmin } from "../services/adminApi";
import { clearToken, getToken } from "../services/tokenStorage";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLogin from "./admin/AdminLogin";

function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authStatus, setAuthStatus] = useState(getToken() ? "checking" : "guest");
  const [adminUser, setAdminUser] = useState(null);
  const [activeTab, setActiveTab] = useState("Prehled");

  const logout = () => {
    clearToken();
    setAdminUser(null);
    setIsAuthenticated(false);
    setAuthStatus("guest");
  };

  useEffect(() => {
    function handleExpiredAuth() {
      logout();
    }

    window.addEventListener("eltt:auth-expired", handleExpiredAuth);
    return () => window.removeEventListener("eltt:auth-expired", handleExpiredAuth);
  }, []);

  useEffect(() => {
    let mounted = true;

    async function verifyToken() {
      if (!getToken()) {
        setAuthStatus("guest");
        return;
      }

      setAuthStatus("checking");
      try {
        const response = await fetchCurrentAdmin();
        if (!mounted) return;
        setAdminUser(response?.user || null);
        setIsAuthenticated(true);
        setAuthStatus("authenticated");
      } catch (error) {
        if (!mounted) return;
        logout();
      }
    }

    verifyToken();
    return () => {
      mounted = false;
    };
  }, []);

  const authenticated = (user) => {
    setAdminUser(user || null);
    setIsAuthenticated(true);
    setAuthStatus("authenticated");
  };

  if (authStatus === "checking") {
    return (
      <section className="page-section">
        <div className="shell">
          <div className="mx-auto max-w-md card p-6">
            <LoadingPlaceholder className="h-6 w-40" />
            <LoadingPlaceholder className="mt-4 h-4 w-full" />
            <LoadingPlaceholder className="mt-3 h-4 w-2/3" />
          </div>
        </div>
      </section>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onAuthenticated={authenticated} />;
  }

  return <AdminDashboard activeTab={activeTab} onTabChange={setActiveTab} onLogout={logout} user={adminUser} onUserUpdated={setAdminUser} />;
}

export default AdminPage;
